// Opening Balance Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Fetch Opening Balance from backend ***** //
export const fetchOpeningBalanceInfo = async ({ commit }) => {
  try {
    const result = await Axios.get(`opening_balance_show/1`)
    commit('fetchOpeningBalanceInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Update Opening Balance info ***** //
export const updateOpeningBalanceInfo = async (ignored, payload = null) => {
  try {
    payload.append('_method', 'PATCH')
    await Axios.post(`opening_balance_update/1`, payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}
